/*@flow*/
import { useEffect } from 'react';
import type { TransformerT } from '../types';

export default function useTransformedValue(
  fieldValue: any,
  transformer: TransformerT,
  onChange: (any) => any
) {
  useEffect(() => {
    if (!fieldValue) return;
    // $FlowFixMe[prop-missing]
    const newValue = transformer.parse(fieldValue);
    newValue && newValue !== fieldValue && onChange(newValue);
  }, [fieldValue]);
}
